import { useSnapshot } from 'valtio'
import format from 'date-fns/format'
import Link from 'next/link'
import React, { type ReactElement } from 'react'
import { parseISO } from 'date-fns'
import { PlaceholderBox } from '../../../../../../../shared/components/ui/PlaceholderBox'
import { ErrorBox } from '../../../../../../../shared/components/ui/ErrorBox'
import DetailLabel from '../../../../../../../shared/components/ui/forms/DetailLabel'
import { usdFormatter } from '../../../../../../../shared/utils/formattingUtils'
import { rpOccurrenceProxy } from '../../rpOccurrenceProxy'
import { buildAppCustomerPath } from '../../../../../../../pages/app/customers/[id]'
import { CardAddSlideOver } from '../../../../../../../shared/components/CardAddSlideOver/CardAddSlideOver'
import {
  handleSubmitToOpenLightboxRetryRpOccurrence
} from '../../../../../../../shared/components/CardAddSlideOver/utils'
import { CardUpdateSlideOver } from './CardUpdateSlideover/CardUpdateSlideOver'
export function RpOccurrenceDetailMainContainer (): ReactElement {
  const snap = useSnapshot(rpOccurrenceProxy)

  const companyName = snap.rpOccurrence?.customer?.companyName
  const customerPath = buildAppCustomerPath(snap.rpOccurrence?.customer?.id ?? '')

  return (
    <div className="bg-white shadow rounded py-4 mb-8 px-6 mr-8">
      <PlaceholderBox loading={snap.apiCall.loading} rows={40} rowHeight="h-5">
        <CardUpdateSlideOver />
        <CardAddSlideOver submitFunction={handleSubmitToOpenLightboxRetryRpOccurrence} />
        <ErrorBox error={snap.apiCall.error}>
          <div className="flex flex-row justify-between">
            <h3 className="text-left text-lg">Occurrence Details</h3>

          </div>

          <div className="flex flex-row">
            <div className="w-2/3 flex flex-col">
              <label className="text-sm text-gray-600">Customer</label>
              <div className="font-medium text-lg">
                <Link href={customerPath} className="font-semibold text-wpy-blue-600 whitespace-nowrap">
                  <span className="mr-2">
                    {snap.rpOccurrence?.customer?.firstName}
                  </span>

                  <span>
                    {snap.rpOccurrence?.customer?.lastName}
                  </span>
                  <span className="ml-4">
                    {companyName ? `(${companyName})` : ''}
                  </span>
                </Link>
              </div>
            </div>

            <DetailLabel additionalOuterClasses="w-1/3" label="Amount" value={snap.rpOccurrence?.amountCents ? usdFormatter.format(snap.rpOccurrence.amountCents) : null} />

          </div>

          <div className="mt-6 flex flex-row ">
            <DetailLabel additionalOuterClasses="w-2/3 " label="Payment Date" value={snap.rpOccurrence?.paymentDate ? format(parseISO(snap.rpOccurrence.paymentDate), 'MMMM d, y') : 'Unspecified'} />
            <DetailLabel additionalOuterClasses="w-1/3 " label="Frequency" value={snap.rpOccurrence?.billingCycle} />
          </div>

        </ErrorBox>
      </PlaceholderBox>
    </div>
  )
}
